import { getMetaMatchSaleList } from "@/lobby_common/api/basic_gen.js";
import { goJoinEvent } from "@/lobby_common/utils/utils.js";
import { mapGetters } from "vuex";
// import left2 from "@/assets/new/turn_left2.png";
// import right2 from "@/assets/new/turn_right2.png";
import star from "@/lobby_common/mixins_views/homeModule/images/star.png";

export default {
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      bannerH5: 175,
      bannerPC: 320,
      value: 0,
      slides: [],
      // left2,
      // right2,
      star,
    };
  },
  filters: {
    time1(time) {
      if (!time) return "";
      var date = new Date(Number(time)); // 初始化日期
      var month = date.getMonth() + 1; // 获取月份
      var day = date.getDate(); // 获取具体日
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      return day + " / " + month;
    },
    time2(time) {
      if (!time) return "";
      var date = new Date(Number(time)); // 初始化日期
      var hour = date.getHours(); // 获取时
      var minutes = date.getMinutes(); // 获取分
      hour = hour < 10 ? "0" + hour : hour;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      return hour + " : " + minutes;
    },
  },
  computed: {
    ...mapGetters(["getIsMobile"]),
    showType() {
      const show_type = this.item.list[0]?.showType || 1;
      return show_type;
    },
    styleMode() {
      const show_type = this.item.list[0]?.showType || 1;
      const showDirection = this.item.list[0]?.showDirection;
      if (show_type === 2) {
        if (showDirection === 1) {
          // 图片在左侧
          return "style2left";
        }
        // 图片在右侧
        return "style2right";
      }
      return "";
    },
    list() {
      return this.slides;
    },
    listPc() {
      // const newArr = [];
      // const num = 3;
      // for (let i = 0; i < this.slides.length; ) {
      //   if (i + num >= this.slides.length) {
      //     newArr.push(
      //       this.slides.slice(this.slides.length - 3, this.slides.length)
      //     );
      //     i += num;
      //   } else {
      //     newArr.push(this.slides.slice(i, (i += num)));
      //   }
      // }
      // return newArr;
      return this.splitArrayIntoGroups(this.slides, 3);
    },
    getPacketConfig() {
      return this.$store.getters.getPacketConfig?.appConfig || {};
    },
    lang() {
      return this.$store.getters.getLang;
    },
    titleAlignment() {
      return this.$store.getters.getPacketConfig?.packetInfo?.config?.titleAlignment
    },
  },
  created() {
    this.getMetaMatchSaleFun();
  },
  mounted() {},
  methods: {
    splitArrayIntoGroups(array, groupSize = 3) {
      const result = [];
      for (let i = 0; i < array.length; i += groupSize) {
        result.push(array.slice(i, i + groupSize));
      }
      return result;
    },
    getFieldByLanguage(field) {
      const obj =
        this.$utils.lang_data(this.lang, this.item.list[0], "langInfoObj") ||
        {};
      //   this.item.list[0]?.langInfoObj[this.lang] || {};
      return obj[field];
    },
    getodds(markets = [], optionId) {
      // 1主 2平 3客
      if (!Array.isArray(markets)) return "";

      const options = markets[0]?.options || [];
      if (options.length === 3) {
        const arr = options?.filter((opt) => Number(opt.optionId) === optionId);
        const obj = arr[0];
        return obj?.odds;
      } else if (options.length === 2) {
        // 新增体育的
        // 4主 5客
        const optionIdMap = {
          1: 4,
          2: "",
          3: 5,
        };
        optionId = optionIdMap[optionId];
        if (!optionId) return "";
        const options = markets[0]?.options || [];
        const arr = options?.filter((opt) => Number(opt.optionId) === optionId);
        const obj = arr[0];
        return obj?.odds;
      }
    },
    async getMetaMatchSaleFun() {
      const config = this.item.list[0]?.config || {};
      const { code, data } = await getMetaMatchSaleList(config);
      if (code === 0) {
        // this.slides = data?.list || [];
        const slides = data?.list || [];
        this.slides = slides.map((item, i) => {
          return {
            ...item,
            eid: `101_22_${this.curindex}_${i}`,
          };
        });
        // console.log("getMetaMatchSaleFun", this.slides);
        if (this.getIsMobile) {
          this.$nextTick(() => {
            this.slideBanner();
          });
        }
      }
    },
    btnCilck(v) {
      this.$eventPost("click", {
        eid: v.eid,
        jump_value: this.item.list[0]?.jump,
        time: Date.now(),
      });
      // 除了多款游戏其他跳转
      goJoinEvent(this.item.list[0]?.jump);
    },
    slideBanner() {
      // 选中的轮播图
      var box = document.querySelector(".mode5-mobileBox");
      if (box !== null) {
        var startPoint = 0;
        var stopPoint = 0;
        // 重置坐标
        var resetPoint = function () {
          startPoint = 0;
          stopPoint = 0;
        };
        // 手指按下
        box.addEventListener("touchstart", function (e) {
          // 手指点击位置的X坐标
          startPoint = e.changedTouches[0].pageX;
        });
        // 手指滑动
        box.addEventListener("touchmove", function (e) {
          // 手指滑动后终点位置X的坐标
          stopPoint = e.changedTouches[0].pageX;
        });
        // 当手指抬起的时候，判断图片滚动离左右的距离
        const that = this;
        box.addEventListener("touchend", function (e) {
          if (stopPoint === 0 || startPoint - stopPoint === 0) {
            resetPoint();
            return;
          }
          if (startPoint - stopPoint > 0) {
            resetPoint();
            that.$refs.mode5SlideCarousel.next();
            return;
          }
          if (startPoint - stopPoint < 0) {
            resetPoint();
            that.$refs.mode5SlideCarousel.prev();
            return;
          }
        });
      }
    },
    // pc 上一张幻灯片
    turnLeft() {
      this.$refs.mode5mode5SlideCarouselPc.prev();
    },
    // pc 下一张幻灯片
    turnRight() {
      this.$refs.mode5mode5SlideCarouselPc.next();
    },
  },
};
